// import types from './mutations-types';

const mutations = {
  // [types.SET_RESEARCH_INFO](state, payload) {
  //   state.researchInfo = payload;
  // },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/research/mutations.js